// MathJax configuration
// This sets up window.MathJax configuration object and loads the MathJax library
// Config comes from MathjaxConfig class (Ruby) via JSON in the page - single source of truth

export function setupMathJaxConfig() {
  // Skip if MathJax is already loaded
  if (window.MathJax && window.MathJax.typesetPromise) {
    console.log('MathJax already loaded');
    return;
  }

  // Read full config from server-rendered JSON (from MathjaxConfig class)
  const configElement = document.getElementById('mathjax-full-config');

  let packages = [];
  let loader = [];
  let displayMath = [['$$', '$$']];
  let inlineMath = [['{$', '$}'], ['$', '$'], ['{', '}'], ['\\(', '\\)']];
  let macros = {};

  if (configElement) {
    try {
      const config = JSON.parse(configElement.textContent);
      packages = config.packages || [];
      loader = config.loader || [];
      displayMath = config.displayMath || displayMath;
      inlineMath = config.inlineMath || inlineMath;
      macros = config.macros || {};
    } catch (e) {
      console.error('Failed to parse MathJax configuration:', e);
    }
  }

  // Set up MathJax configuration BEFORE loading the script
  window.MathJax = {
    options: {
      ignoreHtmlClass: 'trixy'
    },
    loader: {
      load: [...loader, 'a11y/assistive-mml', 'a11y/explorer', 'a11y/semantic-enrich', 'a11y/speech']
    },
    tex: {
      packages: {'[+]': packages},
      displayMath: displayMath,
      inlineMath: inlineMath,
      macros: macros
    },
    svg: {
      fontCache: 'global'
    },
    startup: {
      pageReady: () => {
        return MathJax.startup.defaultPageReady().then(() => {
          console.log('MathJax fully loaded and ready');
          window.dispatchEvent(new Event('mathjax-ready'));
        });
      }
    }
  };

  console.log('MathJax configuration loaded');

  // Now dynamically load the MathJax script (served from public/mathjax symlink → node_modules/mathjax)
  const script = document.createElement('script');
  script.id = 'MathJax-script';
  script.async = true;
  script.src = '/mathjax/tex-svg.js';

  document.head.appendChild(script);
}

// Run immediately
setupMathJaxConfig();
